import API_BASE_URL from "../../utils/apiBase";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Customer_Form.css";
import { toast } from "react-toastify";
import SearchInputComponent from "../../utils/SearchBar";
import RequiredField from "../RequiredField/RequiredField";
import WebcamCapture from '../webCam/WebCamCapture.jsx';
import { useProjects } from "../../utils/projects";
import { FormSection, ChoiceChips, ProjectCards } from "../Registration/fields";

// Chip labels are short; the values are exactly what the old <select>s
// submitted, so stored data and reports are unchanged.
const SIZE_OPTIONS = [
  { value: "1 BHK", label: "1 BHK" },
  { value: "2 BHK", label: "2 BHK" },
  { value: "3 BHK", label: "3 BHK" },
  { value: "4 BHK", label: "4 BHK" },
  { value: "other", label: "Other" },
];

const BUDGET_OPTIONS = [
  { value: "Less than 1Cr*", label: "Under 1 Cr" },
  { value: "1Cr-1.5Cr", label: "1 – 1.5 Cr" },
  { value: "1.5Cr-2cr", label: "1.5 – 2 Cr" },
  { value: "2Cr-2.5Cr", label: "2 – 2.5 Cr" },
  { value: "3Cr-3.5Cr", label: "3 – 3.5 Cr" },
  { value: "4cr-4.5Cr", label: "4 – 4.5 Cr" },
  { value: "4.5Cr-5Cr", label: "4.5 – 5 Cr" },
  { value: "more than 5Cr", label: "5 Cr +" },
  // Reveals a text box; the typed amount is submitted as the budget
  { value: "custom", label: "✎ Custom" },
];

const CustomerForm = (props) => {
  const { projects } = useProjects();
  const location = useLocation();
  const navigate = useNavigate();
  const [salesData, setSalesData] = useState('');
  const [existsCustomer,SetexitsCustomer]=useState([])
   const [uploadedUrl, setUploadedUrl] = useState(null);
  const [errors, setErrors] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    meetingWith: "",
    lastFiveDigits: "",
    imageUpload:""
  });
  
  
  const validateField = async (name, value) => {
    let errorMessage = "";

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "", 
    }));

    // Field-specific validations
    if (name === "name" && !/^[A-Za-z\s]+$/.test(value)) {
      errorMessage = "Name should only contain alphabets and spaces.";
    } else if (name === "phoneNumber" && !/^[0-9]{5}$/.test(value)) {
      errorMessage = "Phone number must be exactly 5 digits.";
    } else if (name === "email" && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      errorMessage = "Please enter a valid email address.";
    } else if (name === "lastFiveDigits" && !/^[0-9]{5}$/.test(value)) {
      errorMessage = "Last five digits must be exactly 5 digits.";
    } else if (name === "meetingWith" && !/^[A-Za-z\s]+$/.test(value)) {
      errorMessage = "Meeting with should only contain alphabets and spaces.";
    }
    

 

    if ((name === "phoneNumber") && value.length === 5) {
      let requestBody = { phoneNumber: value };

      try {
        let response = await fetch(
         `${API_BASE_URL}/api/v1/customer/validation`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          }
        );
        // console.log(response)

        response = await response.json()
        SetexitsCustomer(response.data)
        if (!response.ok) {
          SetexitsCustomer(response.data)
          // errorMessage = `Customer exists under this ${name}`;
        }
      } catch (err) {
        console.error("Validation API error:", err);
        errorMessage = "Error validating customer. Please try again.";
      }
    }
    if ((name === "lastFiveDigits") && value.length === 5) {
      let requestBody = { phoneNumber: value };

      try {
        let response = await fetch(
          `${API_BASE_URL}/api/v1/customer/validation`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          }
        );
        response = await response.json()
        SetexitsCustomer(response.data)
        // console.log(response)
        if (!response.ok) {
          // console.log(response.data)
         
          // errorMessage = `Customer exists under this ${name}`;
        }
      } catch (err) {
        console.error("Validation API error:", err);
        errorMessage = "Error validating customer. Please try again.";
      }
    }

    // Update the error state
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: errorMessage,
    }));
  };

  useEffect(() => {
    // Fetch data from API when component mounts
    fetchUserData();
  }, []);

  useEffect(()=>{

    if(formData?.phoneNumber<5 || formData?.lastFiveDigits<5){
      SetexitsCustomer(()=>[])
    }
  },[])

  const fetchUserData = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/v1/sales`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const responseData = await response.json();
      const { data, message } = responseData;
      if (!response.ok) {
        throw new Error(`${message}`);
      }
    
      setSalesData(data[0].names);
    } catch (error) {
      console.error("Error fetching data:", error);
      setSalesData([]);
      toast.error(`Error: ${error.message}`);
    }
  };

  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    lastFiveDigits: "",
    fullPhoneNumber: "",
    email: "",
    address: "",
    city: "",
    pincode: "",
    occupationType: "",
    designation: "",
    companyName: "",
    meetingWith: "",
    placeOfVisit: "",
    channelPartnerName: "",
    cpEnrolled: "",
    cpPhoneNumber: "",
    cpCompanyName: "",
    cpName: "",
    priceRange: "",
    sizeRange: "",
    date: getCurrentDate(), // Set default value to current date
    imageUrl:uploadedUrl
  });

  // Function to get the current date in the format YYYY-MM-DD
  function getCurrentDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const channelPartner = localStorage.getItem("channel-partner");
  console.log()

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Prevent selecting future dates
    if (name === "date") {
      const selectedDate = new Date(value);
      const currentDate = new Date();

      if (selectedDate > currentDate) {
        // Reset the value to today's date
        setFormData((prevData) => ({
          ...prevData,
          date: getCurrentDate(),
        }));
        return; 
      }
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if(((name === "phoneNumber") && value.length < 5)||((name === "lastFiveDigits") && value.length <5)){
      SetexitsCustomer(()=>[])
    }
    validateField(name, value);
  };

  const clearForm = () => {
    setFormData({
      name: "",
      phoneNumber: "",
      lastFiveDigits: "",
      email: "",
      address: "",
      state: "",
      pincode: "",
      occupationType: "",
      designation: "",
      companyName: "",
      meetingWith: "",
      placeOfVisit: "",
    });
    setUploadedUrl(null)
  };

  const [cpCompanyName, setCpCompanyName] = useState("");
  const [selectedCpName, setSelectedCpName] = useState("");
  const [meetingWith, setMeetingWith] = useState("");

  // Handle the selected value for cpCompanyName
  const handleCpCompanyName = (val) => {
    setSelectedCpName(val);
  };

  // Handle the selected value for meetingWith
  const handleMeetingWith = (val) => {
    const str = val;
    const parts = str.split("-"); // Split the string into parts using the dash
    const result = parts[0]; // Concatenate the first part with " XYZ-" and the second part
    setMeetingWith(result);
  };

  const userName = localStorage.getItem("username");

  const handleCompanyName = async () => {
    setFormData((prevData) => ({
      ...prevData,
      ['phoneNumber']:'',
    }));
    setFormData((prevData) => ({
      ...prevData,
      ['lastFiveDigits']:'',
    }));
    SetexitsCustomer(()=>[])
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/v1/allData/company-names`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json", // Provide headers as an object
          },
        }
      );
      const responseData = await response.json();
      const { data, message } = responseData;

      if (!response.ok) {
        throw new Error(`${message}`);
      }

      setCpCompanyName(() => data); // Update state with fetched data using a callback
    } catch (error) {
      setCpCompanyName("");
      toast.error(`Error: ${error.message}`);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Check if the "Other" option is selected
    if (formData.sizeRange === "other" && (formData.otherSize || "").trim() === "") {
      toast.error("Please provide the size in the 'Other' field");
      return;
    }
    if (formData.priceRange === "custom" && (formData.otherBudget || "").trim() === "") {
      toast.error("Please enter the custom budget");
      return;
    }

    let apiUrl = "";
    let method = "";
    let requestBody = "";
    
    if (channelPartner) {
      apiUrl =   `${API_BASE_URL}/api/v1/channel-partner/customer`;
      method = "POST";
      requestBody = {
        name: formData.name,
        phoneNumber: formData.fullPhoneNumber,
        placeOfVisit: formData.placeOfVisit,
        channelPartnerPhoneNumber: formData.fullPhoneNumber,
        lastFiveDigits: formData.phoneNumber,
        meetingWith: formData.meetingWith,
      };
    } else {
      requestBody = {};
      console.log(formData.phoneNumber,formData.lastFiveDigits)

      // Dynamically include phoneNumber or lastFiveDigits based on which is valid
      if (formData.phoneNumber && formData.phoneNumber.length === 5) {
        requestBody.phoneNumber = formData.phoneNumber;
        requestBody.lastFiveDigit = formData.phoneNumber;
        
      } else if (formData.lastFiveDigits && formData.lastFiveDigits.length === 5) {
        requestBody.lastFiveDigit = formData.lastFiveDigits;
        requestBody.phoneNumber = formData.lastFiveDigits;
      } else {
        toast.error("Please provide a valid 5-digit Phone Number or Last Five Digits.");
        return;
      }

      requestBody = {
        ...requestBody,
        name: formData.name,
        email: formData.email,
        address: formData.address,
        city: formData.city,
        pincode: formData.pincode,
        meetingWith: meetingWith,
        placeOfVisit: formData.placeOfVisit,
        cpEnrolled: selectedCpName,
        budget:
          formData.priceRange === "custom" ? formData.otherBudget.trim() : formData.priceRange,
        requirement:
          formData.sizeRange === "other" ? formData.otherSize : formData.sizeRange,
        date: formData.date,
        createdBy: userName,
        imageUrl:uploadedUrl
      };

      apiUrl =  `${API_BASE_URL}/api/v1/customer/register`;
      method = "POST";
    }

    try {
     
 if(uploadedUrl ==null){
           setErrors((prevErrors) => ({
      ...prevErrors,
      ["imageUpload"]: "please upload image to submit the form",

    }));
    return 
      }
      const response = await fetch(apiUrl, {
        method: method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
     
       document.querySelector(".spinner").classList.add("show");
    

      const responseData = await response.json();
      if (response.ok) {
        setUploadedUrl(null)
        toast.success(`${responseData.message}`);
        setTimeout(() => {
          navigate("/form-selection");
          document.querySelector(".spinner").classList.remove("show");
        }, 2000);
        clearForm();
      } else {
        toast.error(`${responseData.message}`);
        document.querySelector(".spinner").classList.remove("show");
      }
    } catch (error) {
      console.error("Error sending form data:", error.message);
      document.querySelector(".spinner").classList.remove("show");
    }
  };

  // Same list as before, shown once under whichever phone field is active
  const existingMatches =
    existsCustomer?.length > 0 ? (
      <ul className="reg-existing reg-field--full" aria-live="polite">
        {existsCustomer.map((customer) => (
          <li key={customer.id || customer.name}>
            {customer?.name} → {customer?.placeOfVisit}
          </li>
        ))}
      </ul>
    ) : null;

  return (
    <div className="customerFormWrapper">
      <div className="section-head">
        <h2>{channelPartner ? "Add Customer Details" : "Customer Details"}</h2>
        <p className="section-head-sub">
          Register a site visitor · fields marked <span className="req-mark">*</span> are required
        </p>
        {userName && <span className="section-head-user">Registering as {userName}</span>}
      </div>
      <div className="form-container">
        <form onSubmit={handleSubmit}>
          <FormSection step={1} title="Visitor" hint="Who is visiting today">
            <div className="reg-field">
              <label className="reg-label" htmlFor="cf-name">
                Name <RequiredField />
              </label>
              <input
                id="cf-name"
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Visitor's full name"
                autoComplete="off"
                required
              />
              {errors.name && <span className="error">{errors.name}</span>}
            </div>
            <div className="reg-field">
              <span className="reg-label">
                Came through a channel partner? <RequiredField />
              </span>
              <ChoiceChips
                variant="segmented"
                name="cpEnrolled"
                label="Came through a channel partner"
                value={formData.cpEnrolled === "Yes" ? "Yes" : "No"}
                options={[
                  { value: "No", label: "No" },
                  { value: "Yes", label: "Yes" },
                ]}
                onChange={(e) => {
                  handleChange(e);
                  SetexitsCustomer(() => []);
                  if (e.target.value === "Yes") {
                    handleCompanyName();
                  }
                }}
              />
            </div>
            {formData.cpEnrolled === "Yes" && (
              <div className="reg-field reg-field--full">
                <label className="reg-label">Channel partner company</label>
                <SearchInputComponent
                  data={cpCompanyName}
                  selectedValue={(val) => handleCpCompanyName(val, "cpCompanyName")}
                />
                <span className="reg-hint">Start typing to search registered partners</span>
              </div>
            )}
            {formData.cpEnrolled === "Yes" ? (
              <div className="reg-field">
                <label className="reg-label" htmlFor="cf-last5">
                  Last five digits <RequiredField />
                </label>
                <input
                  id="cf-last5"
                  type="tel"
                  inputMode="numeric"
                  name="lastFiveDigits"
                  pattern="[0-9]{5}"
                  maxLength={5}
                  autoComplete="off"
                  placeholder="e.g. 43210"
                  value={formData.lastFiveDigits}
                  onChange={handleChange}
                  required
                />
                {errors.lastFiveDigits && <span className="error">{errors.lastFiveDigits}</span>}
              </div>
            ) : (
              <div className="reg-field">
                <label className="reg-label" htmlFor="cf-phone">
                  Phone · last 5 digits <RequiredField />
                </label>
                <input
                  id="cf-phone"
                  type="tel"
                  inputMode="numeric"
                  pattern="[0-9]{5}"
                  maxLength={5}
                  name="phoneNumber"
                  autoComplete="off"
                  placeholder="e.g. 43210"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  required
                />
                {errors.phoneNumber && <span className="error">{errors.phoneNumber}</span>}
              </div>
            )}
            {existingMatches}
          </FormSection>

          <FormSection step={2} title="Visitor photo" hint="Taken with this device's camera">
            <div className="reg-field reg-field--full">
              <WebcamCapture onUpload={(url) => setUploadedUrl(url)} onDelete={() => setUploadedUrl(null)} />
              {errors.imageUpload && <span className="error">{errors.imageUpload}</span>}
            </div>
          </FormSection>

          <FormSection step={3} title="Requirement & budget" hint="Tap to choose">
            <div className="reg-field reg-field--full">
              <span className="reg-label">Requirement</span>
              <ChoiceChips
                name="sizeRange"
                label="Requirement"
                value={formData.sizeRange}
                options={SIZE_OPTIONS}
                onChange={handleChange}
              />
            </div>
            {formData.sizeRange === "other" && (
              <div className="reg-field reg-field--full">
                <label className="reg-label" htmlFor="cf-other">
                  Other size
                </label>
                <input
                  id="cf-other"
                  type="text"
                  name="otherSize"
                  placeholder="e.g. Penthouse, 2795 sq ft"
                  value={formData.otherSize || ""}
                  onChange={handleChange}
                />
              </div>
            )}
            <div className="reg-field reg-field--full">
              <span className="reg-label">Budget</span>
              <ChoiceChips
                name="priceRange"
                label="Budget"
                value={formData.priceRange}
                options={BUDGET_OPTIONS}
                onChange={handleChange}
              />
            </div>
            {formData.priceRange === "custom" && (
              <div className="reg-field reg-field--full">
                <label className="reg-label" htmlFor="cf-budget-custom">
                  Custom budget <RequiredField />
                </label>
                <input
                  id="cf-budget-custom"
                  type="text"
                  name="otherBudget"
                  placeholder="e.g. 2.5 – 3 Cr, or 6 Cr"
                  value={formData.otherBudget || ""}
                  onChange={handleChange}
                  autoFocus
                  required
                />
              </div>
            )}
          </FormSection>

          <FormSection step={4} title="Visit details">
            <div className="reg-field">
              <label className="reg-label">Meeting with</label>
              <SearchInputComponent
                name="meetingWith"
                data={salesData}
                selectedValue={(val) => handleMeetingWith(val)}
              />
              {errors.meetingWith && <span className="error">{errors.meetingWith}</span>}
            </div>
            <div className="reg-field">
              <label className="reg-label" htmlFor="cf-date">
                Date
              </label>
              <input
                id="cf-date"
                type="date"
                name="date"
                required
                value={formData.date}
                onChange={handleChange}
                max={getCurrentDate()} // Set the max attribute to today's date
              />
            </div>
            <div className="reg-field reg-field--full">
              <span className="reg-label">Place of visit</span>
              <ProjectCards
                name="placeOfVisit"
                value={formData.placeOfVisit}
                projects={projects}
                onChange={handleChange}
              />
            </div>
          </FormSection>

          <button type="submit">Register visitor</button>
        </form>
      </div>
    </div>
  );
};

export default CustomerForm;
